import React, { Component, Fragment } from 'react'
// import ScrollAnimation from 'react-animate-on-scroll'
// import PropTypes from 'prop-types'

import { StepOne, StepTwo, StepThree } from './'

class InquiryForm extends Component {
  constructor (props) {
    super(props)
    this.nextPage = this.nextPage.bind(this)
    this.previousPage = this.previousPage.bind(this)
    this.state = {
      page: 1,
    }
  }
  nextPage () {
    this.setState({ page: this.state.page + 1 })
  }
  previousPage () {
    this.setState({ page: this.state.page - 1 })
  }

  render () {
    const { onSubmit } = this.props
    const { page } = this.state
    return (
      <Fragment>
        {page === 1 &&
          

              <StepOne
              onSubmit={this.nextPage}
            />
           }
        {page === 2 &&


            <StepTwo
            previousPage={this.previousPage}
            onSubmit={this.nextPage}
          />
           }
        {page === 3 &&


            <StepThree
              previousPage={this.previousPage}
              onSubmit={onSubmit}
            /> 
        }
      </Fragment>
    )
  }
}

// InquiryForm.propTypes = {
//   onSubmit: PropTypes.func.isRequired
// }

export default InquiryForm



// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/GettingStarted/components/InquiryForm.js